import React from "react";
import {
  Layout,
  Card,
  Typography,
  Divider,
  Tag,
  Button,
  Row,
  Col,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Content } = Layout;
const { Title, Text } = Typography;

const CharityDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const charityData = location.state?.charityData;

  if (!charityData) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        No charity data found
      </div>
    );
  }

  return (
    <div style={{ padding: 24, background: "#f5f7fb", minHeight: "100vh" }}>
      {/* 🔙 Back */}
      <Button
        icon={<LeftOutlined />}
        type="link"
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16 }}
      >
        Back
      </Button>

      <Layout>
        <Content>
          {/* 🔥 HERO */}
          <div
            style={{
              position: "relative",
              borderRadius: 16,
              overflow: "hidden",
              boxShadow: "0 6px 25px rgba(0,0,0,0.1)",
            }}
          >
            <img
              src={charityData.image}
              alt="charity"
              style={{
                width: "100%",
                height: 220,
                objectFit: "cover",
              }}
            />

            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                padding: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Title level={3} style={{ color: "#fff", margin: 0 }}>
                  {charityData.title}
                </Title>

                {/* <Tag
                  color={
                    charityData.status === "Active" ? "green" : "red"
                  }
                >
                  {charityData.status}
                </Tag> */}
              </div>

              <div style={{ marginTop: 8 }}>
                <Tag color="blue">{charityData.location}</Tag>
                <Tag color="gold">₹ {charityData.charityPrice}</Tag>
              </div>
            </div>
          </div>

          {/* 🔥 DETAILS CARD */}
          <div style={{ marginTop: 24 }}>
            <Card
              style={{
                borderRadius: 16,
                boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
              }}
            >
              {/* Description */}
              <Title level={4}>Description</Title>
              <Text type="secondary">
                {charityData.description || "No description available"}
              </Text>

              <Divider />

              {/* Info Grid */}
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Item Name</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.itemName || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Location</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.location}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Charity Price</Text>
                    <div style={{ marginTop: 6, color: "#52c41a", fontWeight: 600 }}>
                      ₹ {charityData.charityPrice}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Market Price</Text>
                    <div
                      style={{
                        marginTop: 6,
                        textDecoration: "line-through",
                        color: "#999",
                      }}
                    >
                      ₹ {charityData.marketPrice}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Beneficiary Name</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.beneficiaryName || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Total Quantity</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.totalQty || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>User Limit</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.userLimit || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Email</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.email || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Mobile</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.mobile || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Start Date</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.startDate || "N/A"}
                    </div>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>End Date</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.endDate || "N/A"}
                    </div>
                  </Card>
                </Col>

                {/* <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Status</Text>
                    <div style={{ marginTop: 6 }}>
                      <Tag color={charityData.status === "Active" ? "green" : "red"}>
                        {charityData.status}
                      </Tag>
                    </div>
                  </Card>
                </Col> */}

                <Col span={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Charity ID</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.id}
                    </div>
                  </Card>
                </Col>

                <Col span={24}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Created Date</Text>
                    <div style={{ marginTop: 6 }}>
                      {charityData.createdDate || "Auto Generated"}
                    </div>
                  </Card>
                </Col>
              </Row>
            </Card>
          </div>
        </Content>
      </Layout>
    </div>
  );
};

export default CharityDetails;